import React from "react";
import Recaptcha_ from 'react-recaptcha';
import {Helmet} from "react-helmet";
import {config} from 'data/utils/constants';
import styles from './Recaptcha.module.scss';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

export enum eRecaptchaSize {
  normal = 'normal',
  compact = 'compact',
}

interface IRecaptchaProps {
  loading?: boolean;
  size?: eRecaptchaSize;
  onVerify?: (verifyCode) => void;
}

const Recaptcha = ({loading, size, ...props}: IRecaptchaProps) => {
  return (
    <>
      <Helmet>
        <script src="https://www.google.com/recaptcha/api.js?hl=iw" defer/>
      </Helmet>
      <div className={styles.recaptcha} title={"recaptcha"}>
        {loading ? <SkeletonPlaceHolder
          style={{marginLeft: "auto", marginRight: "auto"}}
          width={150}
          height={70}
        /> : <Recaptcha_
          sitekey={config.google.recaptcha}
          render="explicit"
          size={size ? size : (window.outerWidth >= 330 ? eRecaptchaSize.normal : eRecaptchaSize.compact)}
          hl='iw'
          onloadCallback={() => undefined}
          verifyCallback={props.onVerify}

        />}
      </div>
    </>
  );
};

Recaptcha.defaultProps = {
  loading: false,
  onVerify: (verifyCode) => {
    console.log(verifyCode)
  },
};

export default React.memo(Recaptcha);
